<script setup lang="ts">
import SkipButton from "./SkipButton.vue";
</script>

<template>
  <SkipButton class="cards-skip-button">
    {{ $t("label.skipToCards") }}
  </SkipButton>
</template>

<style scoped lang="scss">
@use "@/styles/board";

.cards-skip-button.cards-skip-button {
  position: absolute;
  top: board.len(20px);
  left: board.len(20px);
  padding: board.len(14px);
  border-radius: board.len(8px);
  font-size: board.len(12px);
  line-height: 1.2;

  :deep(> *) {
    height: unset;
  }
}
</style>

<style lang="scss">
// Hide the skip button when there are no cards in the section
*[aria-owns=""] .cards-skip-button {
  display: none;
}
</style>
